<template>
  <div class="card mb-3">
    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
      <h6 class="m-0 font-weight-bold text-primary">ID Card</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form-group col-12 mb-2">
          <div class="row px-3">
            <label for="#form-id_card_number" class="col-lg-4 pl-0 m-0 d-flex align-items-center">ID Card Number</label>
            <input type="text" min="0" class="form-control col-lg-8" :disabled="this.$route.query.id != null ? !is_allow_edit : false" name="id_card_number" id="form-id_card_number" placeholder="ID Card Number" autocomplete="off" v-model="data.id_card_number" @keyup="on_typed_id">
          </div>
        </div>
        <div class="col-12 mt-3">
          <button type="button" name="ktp_upload" id="ktp_upload" class="btn btn-outline-primary btn-sm" role="button" v-show="is_allow_edit" onclick="$('#upload_ktp').trigger('click')">Upload Photo</button>
          <input type="file" name="photo" accept="image/*" class="d-none" id="upload_ktp" v-on:change="display_ktp">
        </div>
        <div class="col-12 mt-3" v-if="data.id_card != ''">
          <img :src="data.id_card" style="height: 12rem">
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: ['data','is_allow_edit',],
  data(){
    return{
      length_id_number: 16,
    }
  },
  // created(){
  //   console.log(this.props.data)
  // },
  methods: {
    on_typed_id(e){
      // console.log(this.data.id_card_number.length)
      if(this.data.id_card_number.length > this.length_id_number)
        this.data.id_card_number = this.data.id_card_number.substring(0,this.length_id_number)
    },
    display_ktp(e){
      this.$emit('on-add-picture',event.target.files[0])
    }
  }
}
</script>
